module.exports = "/dist/3ba8032740f336682ca1f7498bc060fc.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-800.eot
// module id = 20
// module chunks = 0